import { getDynamicSetting } from 'utils/dynamicSettings';

const serverUrl = getDynamicSetting('server_url');

const API_KEYS_ENDPOINT = 'auth/v1/keys';

export const BASE_URL = `${serverUrl}/${API_KEYS_ENDPOINT}`;
